module.exports = __webpack_public_path__ + "img/pic_zhishiku@2x.1d74bd56.png";